/**
 * A generic interface for objects that can notify about property changes.
 */

export type onPropertyChangedFunc<Type> = (arg0: Type) => void;

export interface NotifyPropertyChanged<Type> {
    /**
     * Adds a listener that is called when a property of the object changes.
     * @param listener The listener to add.
     */
    addListener(listener: (arg0: Type) => void): void;

    /**
     * Removes a listener.
     * @param listener The listener to remove.
     */
    removeListener(listener: (arg0: Type) => void): void;
}

export class NotifyPropertyChangedHelper<Type> {
    private readonly _listeners: ((arg0: Type) => void)[] = [];

    public addListener(listener: (arg0: Type) => void): void {
        this._listeners.push(listener);
    }

    public removeListener(listener: (arg0: Type) => void): void {
        const index = this._listeners.indexOf(listener);
        if (index !== -1) {
            this._listeners.splice(index, 1);
        }
    }

    public notifyListeners(arg0: Type): void {
        for (const listener of this._listeners) {
            listener(arg0);
        }
    }

    public clearListeners(): void {
        this._listeners.length = 0;
    }
}
